import { render, staticRenderFns } from "./ShippingMethodsDefault.vue?vue&type=template&id=f8892808"
import script from "./ShippingMethodsDefault.vue?vue&type=script&lang=js"
export * from "./ShippingMethodsDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports